import { keyframes } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IGridResult, IBaseSearchRequest, IFilter } from 'src/app/core/models/base';
import { enumToArray } from 'src/app/shared/helpers/enumToArray';
import { ICompany } from 'src/app/company/models/company';
import { CompanyService } from 'src/app/company/services/company.service';
import { IOrder, IUpdateOrderRequest, OrderStates } from '../models/order';
import { OrderService } from '../services/order.service';
import { map } from 'rxjs';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';

@UntilDestroy()
@Component({
    selector: 'app-order-grid-admin',
    templateUrl: './order-grid-admin.component.html',
    styleUrls: ['./order-grid-admin.component.scss'],
    standalone: false
})
export class OrderGridAdminComponent implements OnInit {

  
  constructor(
    private route: ActivatedRoute,
    private ordersService: OrderService,
    private fb :UntypedFormBuilder,
    private companyService: CompanyService,
  ) { }

  public orders : IGridResult<IOrder[]>;

  filterForm: UntypedFormGroup;

  orderStatesArray;

  companies: ICompany[];

  showReset = false;

  request: IBaseSearchRequest = {
    pageNumber: 0,
    pageSize: 25
  }

  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: "contains",
  };

  ngOnInit(): void {
    this.orders = this.route.snapshot.data['orders'] as IGridResult<IOrder[]>;
    this.initFilterForm();
    this.initOrderStatesArray();
    this.initCompanies();
  }

  initCompanies(){
    this.companyService.listCompanies({pageNumber:0, pageSize: 999999, showRootCompany: false})
    .pipe(untilDestroyed(this))
    .subscribe(response => this.companies = response.data)
  }

  initOrderStatesArray(){
    this.orderStatesArray = enumToArray(OrderStates, 'orders.states.')
  }

  reloadOrders(){
    this.ordersService.listorders(this.request)
    .pipe(
      map(response => { 
        return {
          data: response.data,
          total: response.totalCount
        };
      }),
      untilDestroyed(this)
    )
    .subscribe(filteredOrders => {
      this.orders = filteredOrders;
    });
  }
  

  onReload(request: IBaseSearchRequest){
    this.request.pageNumber = request.pageNumber;
    this.request.pageSize = request.pageSize;
    this.reloadOrders();
  }

  initFilterForm(){
    this.filterForm = new UntypedFormGroup({
      companyId: new UntypedFormControl(),
      internalNumber: new UntypedFormControl(),
      orderState: new UntypedFormControl(),
    })
  }

  onSubmitFilter() {
    const formValues = this.filterForm.value;
    var advancedFilter: IFilter = {
      logic: "and",
      filters: []
    };

    if(formValues.internalNumber){
      const filter: IFilter = {
          field: 'company.internalNumber',
          operator: "contains",
          value: formValues.internalNumber.trim()
        };
        advancedFilter.filters.push(filter);

    }
  
    Object.keys(formValues).forEach(formField => {
      if (formField !== 'internalNumber' && formValues[formField]?.id) {
        // Normal dropdowns (companyId, orderState)
        const valueAsString = formValues[formField].id.toString();
        const filter: IFilter = {
          field: formField,
          operator: "eq",
          value: valueAsString
        };
        advancedFilter.filters.push(filter);
      } else if (formField !== 'internalNumber' && formValues[formField]) {
        // Normal text fields
        const valueAsString = formValues[formField];
        const filter: IFilter = {
          field: formField,
          operator: "contains",
          value: valueAsString.trim()
        };
        advancedFilter.filters.push(filter);
      }
    });

  // Ensure the filter is not empty
  if (advancedFilter.filters.length === 0) {
    this.request.advancedFilter = null;
  } else {
    this.request.advancedFilter = advancedFilter;
  }
  
    this.reloadOrders();
    this.showReset = true;
  }

  onResetFilter(){
    this.filterForm.reset();
    this.request.advancedFilter = null;
    this.showReset = false;
    this.reloadOrders();
  }

  onChangeOrderState(order: IOrder){
    const request : IUpdateOrderRequest = {
      id: order.id,
      orderState: order.orderState == OrderStates.open ? OrderStates.closed : OrderStates.open,
    }
    this.ordersService.updateOrderState(request)
    .pipe(untilDestroyed(this))
    .subscribe(response => {
      this.reloadOrders();
    })
  }

}
